import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=3b77678a&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./OrderList.vue?vue&type=style&index=0&id=3b77678a&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./OrderList.vue?vue&type=style&index=1&id=3b77678a&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3b77678a",
  "12f9294a"
  
)

export default component.exports